<div class="mt-5">
  <div class="row" style="margin: 0">
    <div class="col-12 col-md-12 col-sm-12">
      <div *ngIf="parks.length === 0" style="display: inline-flex" class="mb-1">
        <li
          class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning"
          [style.width]="'100%'"
        >
          Lista vuota. Non hai parchi mezzi assegnati, contatta un
          amministratore di sistema per amministrare dei parchi mezzi.
        </li>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
        <mat-accordion class="example-headers-align" multi>
          <mat-expansion-panel *ngFor="let park of parks; let index = index" (opened)="openChanged(park)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{park.name}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <label class="h3"><b>Calendario Veicoli </b></label>
            <full-calendar [options]="options[park.id]" (resourceRender)="openAssignVehicleDialog($event)"
              (eventRender)="eventRender($event)">
            </full-calendar>
          </mat-expansion-panel>
        </mat-accordion>
    </div>
  </div>
  <app-assign-user-to-car
    (vehicleAssigned)="vehicleAssigned()"
  ></app-assign-user-to-car>
</div>
<ng-template #templateViaggio>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{
        eventCLicked.event.extendedProps.type === "travel"
          ? "VIAGGIO #" + eventCLicked.event.extendedProps.travel_id
          : "FERMO TECNICO #" + eventCLicked.event.extendedProps.tech_shut_id
      }}
    </h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="eventCLicked.event.extendedProps.type === 'travel'">
      <div>
        Utente: {{ eventCLicked.event.extendedProps.userName }}
        {{ eventCLicked.event.extendedProps.userSurname }}
      </div>
      <div>Veicolo: {{ eventCLicked.event.getResources()[0].title }}</div>
      <div>
        Inizio: {{ eventCLicked.event.start | date : "dd/MM/yyyy HH:mm" }}
      </div>
      <div>Fine: {{ eventCLicked.event.end | date : "dd/MM/yyyy HH:mm" }}</div>
      <div>Motivazione: {{ determineMotivationOther(eventCLicked.event.extendedProps) }}</div>
      <div>
        Persone Trasportate: {{ eventCLicked.event.extendedProps.passengers }}
      </div>
    </div>
    <div *ngIf="eventCLicked.event.extendedProps.type === 'technical_shutdown'">
      <div>Veicolo: {{ eventCLicked.event.getResources()[0].title }}</div>
      <div>
        Inizio: {{ eventCLicked.event.start | date : "dd/MM/yyyy HH:mm" }}
      </div>
      <div>Fine: {{ eventCLicked.event.end | date : "dd/MM/yyyy HH:mm" }}</div>
      <div>Motivazione: {{ eventCLicked.event.extendedProps.motivation }}</div>
    </div>
  </div>
</ng-template>
